import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";
import Box from "./Box";
import Label from "./Label";
import { css } from "./Theme";

const Property = props => {
  const styles = css({
    width: "100%",
    px: 4,
    py: 3
  });
  return ___EmotionJSX(Box, {
    css: styles
  }, ___EmotionJSX(Label, {
    uppercase: true
  }, props.name), props.children);
};

export default Property;